import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import SbEditable from 'storyblok-react'

import Carousel from './../Carousel'
import Image from './../Image'
import BatchSmall from './../BatchSmall'
import ButtonPrimary from './../ButtonPrimary'

import styles from './styles.module.scss'

const BlogCarousel = (props) => {

    const { blogPosts } = useStaticQuery(graphql`
        query {
            blogPosts: allStoryblokEntry(
                filter: {
                    field_component: {
                        eq: "blogpost"
                    }
                },
                sort: {
                    fields: field_date_string, 
                    order: DESC
                },
                limit: 5
            ) {
                nodes {
                    uuid
                    slug
                    full_slug
                    content
                }
            }
        }
    `)

    const params = {
        slidesPerView: typeof window != 'undefined' && window.innerWidth > 900 ? 2 : 1.5,
        loop: true,
        centeredSlides: true,
        spaceBetween: typeof window != 'undefined' && window.innerWidth > 900 ? 80 : 30,
        grabCursor: true,
        preloadImages: false
    }

    const getCategory = (category) => {
        if (Array.isArray(category)) {
            return (
                <div className={styles['blog-item__category-wrapper']}> 
                    {category.map((cat, i) => <span key={i} className={styles['blog-item__category']}>{cat.replace('-', ' ')}</span>)}
                </div>
            )
        } else {
            return <span className={styles['blog-item__category']}>{category.replace('-', ' ')}</span>
        }
    }

    return (
        <SbEditable content={props.blok}>
            <section className={styles['blog-carousel']} style={props.blok.white_background && { 'backgroundColor': '#fff' }}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                {blogPosts.nodes.length > 0 ? (
                    <Carousel className={styles['blog-carousel__carousel']} params={params}>
                        {blogPosts.nodes.map((item, i) => {

                            const slug = item.full_slug
                            const blogContent = JSON.parse(item.content)
                            
                            return (
                                <article key={i} className={styles['blog-item']}>
                                    <Link to={`/${slug}`} className={styles['blog-item__inner']}>
                                        <figure className={styles['blog-item__image-wrapper']}>
                                            {blogContent.preview_image && <Image blok={blogContent} className={styles['blog-item__image']} image={blogContent.preview_image} params={{ maxWidth: 750 }} />}
                                            {blogContent.category != '' && getCategory(blogContent.category)}
                                            {blogContent.one_million_thread && (
                                                <div className={styles['blog-item__batch']}>
                                                    <BatchSmall />
                                                </div>
                                            )}
                                        </figure>
                                        <div className={styles['blog-item__content']} style={props.blok.white_background && { 'backgroundColor': '#F6F6F6' }}>
                                            <h4 className={`heading-6 ${styles['blog-item__heading']}`}><b>{blogContent.title.substring(0, 50)}...</b></h4>
                                            <p className={`body ${styles['blog-item__text']}`}>{blogContent.preview_text}</p>
                                            <ButtonPrimary 
                                                link={{
                                                    linktype: 'inner',
                                                    cached_url: '/'
                                                }} 
                                                label='Read article'
                                                className={styles['blog-item__button']}
                                            />
                                        </div>
                                    </Link>
                                </article>
                            )
                        })}
                    </Carousel>
                ) : (
                    <p className='body' style={{ textAlign: 'center' }}>Blog Carousel: Search and select blogposts</p>
                )}
            </section>
        </SbEditable>
    )
}

export default BlogCarousel